module.exports = __webpack_public_path__ + "images/oth-blog-banner-bg.jpg";